import React, { useState } from 'react';
import style from '../group.module.scss';
import { DeleteIcon } from '../../../../../icons';
import { Modal } from '../../../../../components';
import { useMutate, useAppAndBranchId, usePermissions } from '../../../../../hooks';
import { api } from '../../../api';
import { useToast } from '../../../../../../../../../helpers/commonFunction';
import { errorMessage } from '../../../../../utils/error';

type Props = {
	intentId: string;
	groupId: string;
	removeGroupById: (groupId: string) => void;
	refetchGroups: () => void;
	isLocalGroup: boolean;
  groupName: string
};

export function DeleteGroup(props: Props) {
  const { ErrorToast } = useToast()
  const [appId, branchId] = useAppAndBranchId()
  const { intentId, groupId, removeGroupById, refetchGroups, isLocalGroup, groupName } = props
  const [isOpen, setIsOpen] = useState(false)
  const { mutate, loading } = useMutate(api.deleteGroup)
  const canDelete = usePermissions('nlu.Delete')

  return (
    <>
      {canDelete &&
        <button onClick={() => setIsOpen(true)} className={style.delete}>
          <DeleteIcon width="15" height="15" stroke="#292D32" />
        </button>
      }
        <Modal 
          styles={{
            '--ok-btn-bg': '#DE0000',
            '--ok-btn-filter': 'drop-shadow(0px 8px 13px rgba(211, 0, 73, 0.18))',
          }}
          okText="Delete"
          loading={loading}
          onOk={async () => {
            if(isLocalGroup) {
              removeGroupById(groupId)
              return
            }
            try {
              await mutate(appId, branchId, intentId, groupId)
              refetchGroups()
              setIsOpen(false)
            } catch(err) {
              ErrorToast(errorMessage("delete", "data labelling group", err.code))
            }
          }}
          onCancel={() => setIsOpen(false)}
          isOpen={isOpen}
          title="Remove Chosen Group"
        >
          <div style={{
            padding: '18px 14px',
            color: '#393939',
            fontSize: 15,
            fontWeight: 500,
          }}>
            <p>Do you really want to remove the chosen group?</p>
            <span className="modal-delete-entity">{groupName}</span>
          </div>
        </Modal>
      </>
  )
}
